import geneSetActionTypes from './actionTypes';
import { createAsyncRequestReducer } from '../../util/fetchReducers';
import { combineReducers } from 'redux';

export const reducers = {
  queryGeneSets: createAsyncRequestReducer(geneSetActionTypes.FETCH_GENESETS),
  createGeneSet: createAsyncRequestReducer(geneSetActionTypes.CREATE_GENESET),
  deleteGeneSet: createAsyncRequestReducer(geneSetActionTypes.DELETE_GENESET),
  updateGeneSet: createAsyncRequestReducer(geneSetActionTypes.UPDATE_GENESET),
  queryGenes: createAsyncRequestReducer(geneSetActionTypes.FETCH_GENES),
};

export default combineReducers(reducers);
